import React from 'react';
import * as PropTypes from 'prop-types';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import Button from './Button';
import { SubjectPropType } from '../../abilities/proptypes';

const AccountingButton = ({
    children,
    onClick,
    disabled,
    subject,
    action,
    className,
    variant,
    color,
    size,
}) => (
    <Button
        startIcon={<AccountBalanceIcon />}
        onClick={onClick}
        disabled={disabled}
        subject={subject}
        action={action}
        variant={variant}
        color={color}
        size={size}
        className={className}
    >
        {children}
    </Button>
);

AccountingButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
};

AccountingButton.defaultProps = {
    onClick: null,
    disabled: false,
    subject: null,
    action: null,
    variant: undefined,
    color: undefined,
    size: undefined,
    className: null,
};

export default AccountingButton;
